<div class="login-screen">
  <div class="fixed top-0 left-0 z-100 w-full h-full">
    <img src="/assets/images/bg-login.png" class="w-full h-full object-cover" />
  </div>
  <div class="glass-card">
    <div class="logo">
      <app-small-logo [size]="48"></app-small-logo>
    </div>

    <div class="welcome-text">
      Te damos la bienvenida<br />
      a HORUS
    </div>

    @if (authState.loginMutation.result$ | async; as loginResult) {
      @if (loginResult.isPending) {
        <div class="loading-container">
          <app-horus-loading [size]="'M'"></app-horus-loading>
        </div>
      } @else {
        <div class="auth-options">
          <app-microsoft-button
            [text]="'Ingresa con Microsoft'"
            (click)="onMicrosoftLogin()"
            data-testid="microsoft-login-button"
          >
          </app-microsoft-button>

          <div class="or-divider">o si no accede con</div>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form max-w-[210px] mx-auto">
          <app-floating-input
            label="Correo electrónico"
            type="email"
            formControlName="email"
            [error]="emailInvalid ? 'Correo electrónico inválido' : ''"
          >
          </app-floating-input>

          <app-floating-input
            label="Contraseña"
            type="password"
            formControlName="password"
            [error]="passwordInvalid ? 'Contraseña inválida' : ''"
          >
          </app-floating-input>

          @if (authState.error()) {
            <div class="error-message">
              {{ authState.error() }}
            </div>
          }

          <button
            type="submit"
            class="w-full"
            horusBtn
            horusBtnVariant="default"
            horusBtnSize="md"
            [disabled]="loginForm.invalid"
            data-testid="login-submit-button"
          >
            INICIAR SESIÓN
          </button>
        </form>
      }
    } @else {
      <div class="auth-options">
        <app-microsoft-button
          [text]="'Ingresa con Microsoft'"
          (click)="onMicrosoftLogin()"
          data-testid="microsoft-login-button"
        >
        </app-microsoft-button>

        <div class="or-divider">o si no accede con</div>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form max-w-[210px] mx-auto">
        <app-floating-input
          label="Correo electrónico"
          type="email"
          formControlName="email"
          [error]="emailInvalid ? 'Correo electrónico inválido' : ''"
        >
        </app-floating-input>

        <app-floating-input
          label="Contraseña"
          type="password"
          formControlName="password"
          [error]="passwordInvalid ? 'Contraseña inválida' : ''"
        >
        </app-floating-input>

        @if (authState.error()) {
          <div class="error-message">
            {{ authState.error() }}
          </div>
        }

        <button
          type="submit"
          class="w-full"
          horusBtn
          horusBtnVariant="default"
          horusBtnSize="md"
          [disabled]="loginForm.invalid"
          data-testid="login-submit-button"
        >
          INICIAR SESIÓN
        </button>
      </form>
    }
  </div>
</div>
